import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

export default function ConditionsGenerales() {
  return (
    <div className="min-h-screen bg-white font-[Manrope,sans-serif]">
      <Navbar />

      <section className="pt-40 pb-20 bg-[#0A1628]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <span className="inline-block px-4 py-1.5 border border-white/20 rounded-full text-xs font-semibold tracking-widest uppercase text-white/50 mb-6">
            Mentions légales
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white">Conditions générales</h1>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          {/* Company box */}
          <div className="bg-[#F7F8FA] rounded-2xl p-8 mb-12">
            <h2 className="text-lg font-bold text-[#0A1628] mb-4">Informations entreprise</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
              {[
                { label: 'Nom', value: 'CICHORZ' },
                { label: 'Dirigeant', value: 'Mariusz Slawomir Cichorz' },
                { label: 'Statut', value: 'Entrepreneur individuel' },
                { label: 'SIRET', value: '102 737 178 00016' },
                { label: 'Adresse', value: '57 Rue Lecourbe, 75015 Paris, France' },
                { label: 'Code APE', value: '62.01Z – Programmation informatique' },
              ].map((item) => (
                <div key={item.label}>
                  <p className="text-xs font-semibold tracking-widest uppercase text-[#6B7280]">{item.label}</p>
                  <p className="text-[#0A1628] font-medium mt-1">{item.value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-bold text-[#0A1628] mb-4">1. Objet</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-8">
              Les présentes conditions générales régissent l&apos;utilisation du site internet de CICHORZ
              ainsi que les relations entre l&apos;entreprise et ses clients. En accédant au site, l&apos;utilisateur
              accepte sans réserve les présentes conditions.
            </p>

            <h2 className="text-2xl font-bold text-[#0A1628] mb-4">2. Services</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-4">
              Le site présente les services de programmation informatique proposés par CICHORZ, notamment :
            </p>
            <ul className="list-none flex flex-col gap-3 mb-8">
              {[
                'Développement logiciel sur mesure',
                'Création de sites et applications web',
                'Maintenance et support technique',
                'Solutions informatiques adaptées',
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-[#374151] text-base">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#0A1628] flex-shrink-0">
                    <i className="ri-check-line text-white text-xs" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <h2 className="text-2xl font-bold text-[#0A1628] mb-4">3. Propriété intellectuelle</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-8">
              L&apos;ensemble des contenus présents sur ce site (textes, images, code, logos) est protégé
              par le droit de la propriété intellectuelle. Toute reproduction, même partielle, est interdite
              sans autorisation préalable écrite de CICHORZ.
            </p>

            <h2 className="text-2xl font-bold text-[#0A1628] mb-4">4. Responsabilité</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-8">
              CICHORZ s&apos;efforce d&apos;assurer l&apos;exactitude et la mise à jour des informations diffusées
              sur ce site, mais ne saurait être tenu responsable des erreurs ou omissions éventuelles.
            </p>

            <h2 className="text-2xl font-bold text-[#0A1628] mb-4">5. Droit applicable</h2>
            <p className="text-[#374151] text-base leading-relaxed mb-8">
              Les présentes conditions générales sont soumises au droit français. En cas de litige,
              les tribunaux français seront seuls compétents.
            </p>

            <h2 className="text-2xl font-bold text-[#0A1628] mb-4">6. Contact</h2>
            <p className="text-[#374151] text-base leading-relaxed">
              Pour toute question relative aux présentes conditions, vous pouvez nous contacter à l&apos;adresse :{' '}
              <a href="mailto:mariuszcichorz@inbox.eu" className="text-[#0A1628] underline font-medium cursor-pointer">
                mariuszcichorz@inbox.eu
              </a>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
